{
  "lang": "nl",
  "theme": "rvr",
  "master": "./masters/rvr/jumplist",
  "plugins": [
    "Dialogue",
    "a11y-describedby",
    "a11y-user-detect",
    "bb-input-wrap-and-unit",
    "control-filter",
    "custom-checkboxes",
    "dialog",
    "final-node",
    "has-required",
    "heading2-3",
    "high-on-info-tb",
    "history",
    "iconset",
    "inspector",
    "lightbox",
    "md-labels",
    "model-filter",
    "modelitem",
    "no-login",
    "no-menu",
    "non-indenting-jumplist",
    "nonce-metatag",
    "nta:proxymap",
    "optional",
    "piwik-pro-nonce",
    "progressbar",
    "questionlabelgroup-ng",
    "reset-password",
    "selected-model",
    "show-server-side-validation",
    "showdown",
    "showdown-converter",
    "xsl-to-pdf"
  ],
  "overrideinloghtml": "rechtwijzer-main.html",
  "a11y": {
    "captions": false,
    "optionfieldsets": true,
    "strictlegends": true
  },
  "arbitrary": {
    "jumplisttitle": "Stappen:",
    "showdown": {
      "policy": "legacy"
    },
    "core": {
      "skipNumButtons": true
    },
    "previews": {
      "autoload": true,
      "singular": true,
      "showChanges": false
    },
    "piwik": {
      "fallback": {
        "code": "1cb006c7-51c6-4a48-a7bf-ebd3e28b0fd1",
        "endpoint": "https://rvr.containers.piwik.pro/"
      }
    },
    "inspector": {
      "xslt-only": true
    }
  },
  "template": {
    "logo": "logo-main",
    "header-lists-modelname": true,
    "less": {
      "post": [
        "jumplist.less",
        "lightbox.less",
        "required.less"
      ]
    },
    "readonly-prop": "disabled"
  },
  "legacy": false
}
